import type { TextMatchTransformer } from "@lexical/markdown";
import type { ElementNode, LexicalNode, TextNode } from "lexical";

import {
  $createCitationNode,
  $isCitationNode,
  CitationNode,
} from "../nodes/CitationNode";

export const CitationTransformer: TextMatchTransformer = {
  type: "text-match",
  dependencies: [CitationNode],
  importRegExp: /(?:\[([^\]]+)\])(?:\(alaffia:\/\/file-preview\/([^\s)]+)\))/,
  regExp:
    /(?:\[([^\]]+)\])(?:\(alaffia:\/\/file-preview\/([^\s)]+)\))(?=[\s,.;:!?)\]"'“”]|$)/,
  trigger: ")",
  replace: (node: TextNode, match: RegExpMatchArray) => {
    const citationKey = match[1];
    if (!citationKey) return;
    const href = `alaffia://file-preview/${match[2] ?? citationKey}`;
    const citationNode = $createCitationNode(citationKey, href);
    node.replace(citationNode);
  },
  export: (
    node: LexicalNode,
    _exportChildren: (node: ElementNode) => string,
  ) => {
    if (!$isCitationNode(node)) {
      return null;
    }
    return `[${node.getCitationKey()}](${node.getHref()})`;
  },
};
